module.exports = __webpack_public_path__ + "img/temple_pin_selected.3872d6b1.png";